import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { workspaceRouteForRole } from '@/config/authAllowlist';
import { useAuth } from '@/hooks/useAuth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

export function LoginRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    return <Navigate to={workspaceRouteForRole(user.role)} replace />;
  }

  return <>{children}</>;
}
